import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import "es6-string-polyfills";
import './index.scss';

import initStore from 'src/storeState';
import generalStore from 'storeState/general';
import * as persistenceActions from 'storeState/persistence/action';

const renderApp = () => {
  const { store } = initStore();

  let isInizialized = false;
  const onStoreUpdate = () => {
    console.log("store.getState()",store.getState())
    if (!isInizialized && store.getState().localPersistence.inizialized) {
      isInizialized = true;
      setTimeout(() => {
        ReactDOM.render(
          <App store={store} />,
          document.getElementById('root')
        );
      }, 50);
    }
  }
  store.subscribe(onStoreUpdate);

  setTimeout(()=>{
    store.dispatch(persistenceActions.enableLocalStoragePersistenceMiddleware());
    persistenceActions.loadReduxStoreFromLocalStorage().then(loadAction => {
      if(loadAction) {
        store.dispatch(loadAction);
      }
    });
  });

  store.dispatch(generalStore.actions.generalBaseRequest());
}

const runMyApp = () => {
  renderApp();
}

if (!global.Intl) {
    require.ensure([
        'intl',
        'intl/locale-data/jsonp/en.js',
        'intl/locale-data/jsonp/de.js'
    ], function (require) {
        require('intl');
        require('intl/locale-data/jsonp/en.js');
        require('intl/locale-data/jsonp/de.js');
        runMyApp()
    });
} else {
    runMyApp()
}



// WEBPACK FOOTER //
// ./src/index.js